/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import SearchFilterSection from "../../components/common/SearchFilterSection";
import Consumer from "../../components/tables/Consumer";
import { getUniqueValues } from "../../libs/UnauthorisedPage";
import { getApiCaller } from "../../libs/apiCaller";

const ConsumerList = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showConsumerList, setShowConsumerList] = useState([]);
  const [filteredConsumers, setFilteredConsumers] = useState([]);
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  useEffect(() => {
    getConsumerList();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedState, selectedCity]);

  const getConsumerList = async () => {
    setIsLoading(true);
    try {
      const response = await getApiCaller(`consumers_list`);
      if (response?.data?.response_code === 200) {
        const consumers = response?.data?.response_data;
        setShowConsumerList(consumers);
        setFilteredConsumers(consumers);
        setStates(getUniqueValues(consumers, "billing_state"));
      }
    } catch (error) {
      console.log("Error fetching consumers:", error);
    }
    setIsLoading(false);
  };

  const applyFilters = () => {
    let filteredData = showConsumerList;

    if (searchTerm) {
      filteredData = filteredData.filter((consumer) => {
        const fullName = `${consumer?.first_name || ""} ${
          consumer.last_name || ""
        }`?.toLowerCase();
        return fullName?.includes(searchTerm?.toLowerCase());
      });
    }

    if (selectedState) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_state === selectedState
      );
      setCities(getUniqueValues(filteredData, "billing_city"));
    } else {
      setCities(getUniqueValues(showConsumerList, "billing_city"));
    }

    if (selectedCity) {
      filteredData = filteredData.filter(
        (consumer) => consumer.billing_city === selectedCity
      );
    }

    setFilteredConsumers(filteredData);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedState("");
    setSelectedCity("");
    setFilteredConsumers(showConsumerList);
    setCities(getUniqueValues(showConsumerList, "billing_city"));
  };

  return (
    <div className="px-4 md:px-10">
      <div className="border border-1 px-4 py-3 rounded-t-2xl mt-4 bg-white">
        <p className="text-[#284184] font-bold text-xl">All Consumers</p>
      </div>
      <div className="border border-t-0 px-4 py-3 rounded-b-2xl text-xl bg-white">
        <SearchFilterSection
          searchTextPlaceholder={"Search Consumer"}
          searchTerm={searchTerm}
          selectedCity={selectedCity}
          selectedState={selectedState}
          cities={cities}
          states={states}
          clearFilters={clearFilters}
          setSearchTerm={setSearchTerm}
          setSelectedCity={setSelectedCity}
          setSelectedState={setSelectedState}
        />

        {/* Consumer Table */}
        <Consumer
          isLoading={isLoading}
          showConsumerList={filteredConsumers}
          setShowConsumerList={setShowConsumerList}
          getConsumerList={getConsumerList}
        />
      </div>
    </div>
  );
};

export default ConsumerList;
